export default "__VITE_ASSET__CxhW9a8o__"